import { getSwedishDateTimeToday } from '@fora-monorepo/date-utils';

const successful = { timeStamp: getSwedishDateTimeToday() };
const error = { message: 'not ok' };

export const mockReportPayroll = {
  successful,
  error,
};
